import { render, staticRenderFns } from "./StoredValue.vue?vue&type=template&id=2a626415&scoped=true"
import script from "./StoredValue.vue?vue&type=script&lang=js"
export * from "./StoredValue.vue?vue&type=script&lang=js"
import style0 from "./StoredValue.vue?vue&type=style&index=0&id=2a626415&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a626415",
  null
  
)

export default component.exports